import axios from 'axios';
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';
import { ERROR_GET_MP_OFFERS } from '../../common/i18n';
import { INFINITE } from '../../common/constants';
import { prepareSearchQuery } from './helper';

export function* getMarketPlaceOffersWatcherSaga() {
  yield takeLatest(types.GET_MP_OFFERS_CALL_REQUEST, workerSaga);
}

export function fetchData(searchParams) {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/offer/${client}/marketplace/`;

  const params = {
    page_size: INFINITE,
    ...searchParams,
  };

  return axios.get(url, { params })
    .then(val => val)
    .catch(err => err);
}

export function* workerSaga({locations, industries, brands}) {
  try {
    const searchParams = prepareSearchQuery(locations, industries, brands);
    const response = yield call(fetchData, searchParams);

    if (response && response.status === 200) {
      const { data } = response;

      yield put({ type: types.GET_MP_OFFERS_CALL_SUCCESS, data });

    } else {
      yield put({ type: types.GET_MP_OFFERS_CALL_FAILURE, error: ERROR_GET_MP_OFFERS});
    }
  } catch (error) {
    yield put({ type: types.GET_MP_OFFERS_CALL_FAILURE, error });
  }
}
